import script from "./ml-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-switch.vue?vue&type=script&setup=true&lang=js"

import "./ml-switch.vue?vue&type=style&index=0&id=319bc176&lang=scss"

const __exports__ = script;

export default __exports__